import gql from "graphql-tag";
const invokeSimQuery = gql(` 
query invokeSim($event: AWSJSON!) {
  invokeSim(event: $event) {
    status
  }
}
`)
export default invokeSimQuery;
